export const CREATED = 'CREATED';
export const CONFIRMED = 'CONFIRMED';
export const WAITING_FOR_BUSINESS_APPROVAL = 'WAITING_FOR_BUSINESS_APPROVAL';
export const CANCELED = 'CANCELED';
export const SETTLED = 'SETTLED';
